<script lang="ts">
    import type {Readable, Writable} from "svelte/store";
    import {derived, writable} from "svelte/store";
    import {_} from "svelte-i18n";
    import type { CommitsToolBoxManager } from "./CommitsToolBoxManager";
    import ToolBoxModal from "../toolbox/ToolBoxModal.svelte";
    import { onMount } from "svelte";
    import { GitFork } from 'lucide-svelte';

    export let manager: CommitsToolBoxManager;
    let openToolBox = manager.getOpenToolBoxStore();
    let visible = manager.getVisibleStore();
    let history = manager.getHistoryStore();
    let snapshotDate: Readable<string> = derived(history, $history => $history?.snapshotCommit?.tags?.diff_day);

    onMount(async () => {
        await manager.initializeAsync();
    });

    function formatTimestamp(timestamp: string): string {
        let hhmm: '2-digit' | undefined = '2-digit'
        if (timestamp.length === 8) {
            timestamp = timestamp.slice(0, 4) + "-" + timestamp.slice(4, 6) + "-" + timestamp.slice(6, 8)
            hhmm = undefined
        }
        const dt = new Date(timestamp)
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: hhmm,
            minute: hhmm
        };
        return dt.toLocaleString(undefined, options)
    }
</script>

<ToolBoxModal isOpen={$openToolBox === "commits"} title="{$_('impact.map.commitsToolbox.title')}">
    <label class="mb-8 mt-2">
        <input bind:checked={$visible} type=checkbox>
        {$_('impact.map.commitsToolbox.changesLayerLabel')}
    </label>

    <h3>{$_('impact.map.commitsToolbox.previousChangesTitle')}</h3>
    <ul>
        {#each $history.commits.slice(0, $history.commits.length - 1) as commit}
            <li class="mt-1">
                <div>
                    <b>{commit.comment}</b>
                    <button class="btn ms-1 p-1 border-0 bg-transparent" on:click={() => manager.forkToNewScenario(commit).then()}><GitFork strokeWidth=2 size=20 /></button>
                </div>
                <div>
                    {formatTimestamp(commit.timestamp)}
                </div>
            </li>
        {/each}
    </ul>

    {$_('impact.map.commitsToolbox.forkMoment', {values: {date: formatTimestamp($history.commits.at(-1).timestamp)}})}
    <br/>
    {#if $snapshotDate}
        {$_('impact.map.commitsToolbox.originalDataMoment', {values: {date: formatTimestamp($snapshotDate)}})}
    {/if}
</ToolBoxModal>
